import { render, staticRenderFns } from "./ProfileDepartments.vue?vue&type=template&id=2e838b6f"
import script from "./ProfileDepartments.vue?vue&type=script&lang=js"
export * from "./ProfileDepartments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports